import io from 'socket.io-client'
import Config from '@/config'
import utils from '@/util'
import EvenBus from '@/eventBus'
import store from './store'

let socket = null
let socketId = null
let isSocketTransportChanged = false

export default {
  init: (cb, accessCode, audienceId) => {
    const query = {
      type: 'audience',
      accessCode,
      audience: audienceId,
    }

    if (store.state.audienceName) {
      query.audienceName = store.state.audienceName
    }

    socket = io(Config.baseUrlSocket, {
      path: '/api/socket.io-client',
      query,
      transports: ['websocket'],
      withCredentials: true,
      auth: {
        audienceId,
      },
    })

    // https://ahaslides.atlassian.net/browse/AHA-4956
    // on reconnection, reset the transports option, as the Websocket
    // connection may have failed (caused by proxy, firewall, browser, ...)
    socket.io.on('reconnect_attempt', (numberOfAttemps) => {
      if (!socketId && isSocketTransportChanged) {
        utils.gaTrackEvent('Audience', 'Socket > Reconnect', `Attemp No. ${numberOfAttemps}`)
      }

      socket.io.opts.transports = ['polling', 'websocket']
      isSocketTransportChanged = true
    })

    socket.on('connect', () => {
      cb(socket.id)
      socketId = socket.id
      socket.on(socket.id, (doc) => {
        if (
          !store.state.presentation.audiencePacing &&
          doc.slideActive == store.state.slide.id &&
          doc.quizStatus > store.state.slide.quizStatus
        ) {
          store.dispatch('updateSlide', {
            quizStatus: doc.quizStatus,
            quizTimeStamp: doc.quizTimeStamp,
          })
        }

        if (utils.isIosSafary() && store.state.slide && doc.slideActive != store.state.slide.id) {
          EvenBus.$emit('confirmNextSlide', doc.slideActive)
        }
      })
    })
  },

  subscribe: (channel, callback) => {
    socket.on(channel, (doc) => {
      return callback(doc)
    })
  },

  unSubscribe: (channel) => {
    if (!socket) {
      return
    }
    socket.removeAllListeners(channel)
  },

  getSocketId: () => {
    return socket.id
  },

  close: () => {
    if (!socket) return
    socket.close()
  },

  getSocket: () => {
    return socket
  },
}
